(function() {

    'use strict';



    var XML2 = SAPO.Utility.XML2,
        VAST = SAPO.Project.Video.VAST;



    function SawBuilder(item, parentEl) {
        var aEl, dEl, topEl, titleEl, linkEl, pEl, i, I;
        if (item.adLinkUrl) {
            aEl = document.createElement('a');
            aEl.href = item.adLinkUrl;
            aEl.target = '_blank';
            aEl.setAttribute('rel', 'external');
            topEl = aEl;
        }
        else {
            dEl = document.createElement('p');
            topEl = dEl;
        }

        if (item.title) {
            titleEl = document.createElement('span');
            titleEl.className = 'title';
            titleEl.appendChild( document.createTextNode(item.title) );
            topEl.appendChild(titleEl);
        }

        if (item.displayUrl) {
            linkEl = document.createElement('span');
            linkEl.className = 'link';
            linkEl.appendChild( document.createTextNode(item.displayUrl) );
            topEl.appendChild(linkEl);
        }

        for (i = 0, I = item.lines.length; i < I; ++i) {
            pEl = document.createElement('span');
            pEl.className = 'line';
            pEl.appendChild( document.createTextNode( item.lines[i] ) );
            topEl.appendChild(pEl);
        }

        topEl.className = 'adword';

        parentEl.appendChild(topEl);
    }



    function SawHdlr(item) {
        if (
            item.nodeName !== 'StaticResource' ||
            item.type     !== 'application/saw'
        ) { return; }

        var el = XML2.parseDOM( item.src );
        var adReqEl = XML2.getChildren(el, 'AdReq')[0];

        if (!adReqEl) { return; }

        var items = VAST.parsers.AdReq(adReqEl);

        var items2 = [];
        for (var it, i = 0, I = items.length; i < I; ++i) {
            it = items[i];
            if (!it) { continue; }
            items2.push({
                mimeType:    'application/saw',
                description: 'non-linear adword',
                item:        it,
                builder:     SawBuilder
            });
        }

        if (items2.length === 0) { return; }

        return items2;
    }



    VAST.handlers.Saw = SawHdlr;

})();
